import { inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Apollo } from 'apollo-angular';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorType } from '../../models/error.types';
import {
  changeEmailMutation,
  verifyEmailMutation
} from '../queries/resident.queries';

@Injectable({
  providedIn: 'root'
})
export class ResidentFacade {
  private apollo = inject(Apollo);

  public verifyEmail(
    token: string,
    verificationCode: string,
    customerIdent: string
  ) {
    const input = {
      token,
      verificationCode
    };
    return this.apollo
      .use('resident')
      .mutate<boolean>({
        mutation: verifyEmailMutation,
        variables: {
          input
        },
        context: {
          headers: new HttpHeaders().set('X-Customer-Ident', customerIdent)
        }
      })
      .pipe(
        map(response => response.data),
        catchError((error: Error) => {
          if (error.message === ErrorType.RESIDENT_ALREADY_VERIFIED) {
            return of(true);
          }
          throw new Error(error.message);
        })
      );
  }

  public changeEmail(token: string, customerIdent: string) {
    const input = {
      token
    };
    return this.apollo
      .use('resident')
      .mutate<{ success: boolean }>({
        mutation: changeEmailMutation,
        variables: {
          input
        },
        context: {
          headers: new HttpHeaders().set('X-Customer-Ident', customerIdent)
        }
      })
      .pipe(map(response => response.data.success));
  }
}
